import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PaginationAccordionTable from './pagination-accordion-table';
import { RootState } from '../../../store/root-reducer';
import {
  downloadEmailVerifiedFileRequest,
  getVerifiedEmailFileDetailsByIdRequest,
} from '../extra-action';
import {
  DownloadEmailVerifiedFilePayload,
  GetUploadedFilePayload,
} from '../types';
import {
  resetDownloadEmailVerifiedFileRequest,
  resetPagination,
  setIsVerifiedEmailData,
} from '../email-verifier-slice';

const PaginationAccordionTableContainer: React.FC<{
  getEmailVerifierUploadedFilesListRequest?: (
    payload: GetUploadedFilePayload,
  ) => void;
}> = memo(({ getEmailVerifierUploadedFilesListRequest }) => {
  const pollingNotifications = useSelector(
    (state: RootState) => state?.home?.pollingNotifications,
  );

  const uploadFileRequestStatus = useSelector(
    (state: RootState) =>
      state?.emailVerifier?.emailVerifierUploadedFilesListRequest,
  );

  const {
    emailVerifications: emailVerifierUploadedFilesList,
    total: totalEmailVerifierUploadedFilesList,
  } = useSelector(
    (state: RootState) => state?.emailVerifier?.emailVerifierUploadedFilesList,
  );

  const downloadEmailVerifiedFileRequestStatus = useSelector(
    (state: RootState) =>
      state?.emailVerifier?.downloadEmailVerifiedFileRequest?.status,
  );

  const paginationState = useSelector(
    (state: RootState) => state?.emailVerifier?.setSearchPaginationState,
  );

  const dispatch = useDispatch();
  const downloadEmailVerifiedFileRequests = useCallback(
    (payload: DownloadEmailVerifiedFilePayload) => {
      dispatch(downloadEmailVerifiedFileRequest(payload));
    },
    [dispatch],
  );

  const setIsVerifiedEmailDatas = useCallback(
    (payload: string) => {
      dispatch(setIsVerifiedEmailData(payload));
    },
    [dispatch],
  );

  const resetDownloadEmailVerifiedFileRequests = useCallback(() => {
    dispatch(resetDownloadEmailVerifiedFileRequest());
  }, [dispatch]);

  const getVerifiedEmailFileDetailsByIdRequests = useCallback(
    (payload: number) => {
      dispatch(getVerifiedEmailFileDetailsByIdRequest(payload));
    },
    [dispatch],
  );

  const resetPaginationPage = useCallback(() => {
    dispatch(resetPagination());
  }, [dispatch]);

  return (
    <PaginationAccordionTable
      pollingNotifications={pollingNotifications}
      uploadFileRequestStatus={uploadFileRequestStatus}
      emailVerifierUploadedFilesList={emailVerifierUploadedFilesList}
      totalEmailVerifierUploadedFilesList={totalEmailVerifierUploadedFilesList}
      downloadEmailVerifiedFileRequestStatus={
        downloadEmailVerifiedFileRequestStatus
      }
      paginationState={paginationState}
      downloadEmailVerifiedFileRequests={downloadEmailVerifiedFileRequests}
      getEmailVerifierUploadedFilesListRequest={
        getEmailVerifierUploadedFilesListRequest
      }
      setIsVerifiedEmailDatas={setIsVerifiedEmailDatas}
      resetDownloadEmailVerifiedFileRequests={
        resetDownloadEmailVerifiedFileRequests
      }
      getVerifiedEmailFileDetailsByIdRequests={
        getVerifiedEmailFileDetailsByIdRequests
      }
      resetPaginationPage={resetPaginationPage}
    />
  );
});

export default PaginationAccordionTableContainer;
